import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { PageHeader, IframeView } from '../../components';
import { META_TITLE } from '../../utils/constants';
import { buildIframeUrl } from '../../utils/iframe';
import * as S from './Profile.styles';

export default function Profile() {
	const user = useSelector((state) => state.user.value);
	const currentLocation = useSelector((state) => state.location.value);
	const { search } = useLocation();

	// New profiles (no locations) and the "Add New Address" entry point go straight to the add location process
	const hasLocations = (user?.locations?.length || 0) > 0;
	const isAddLocation = !hasLocations || new URLSearchParams(search).get('addLocation') === 'true';

	const src = isAddLocation ? buildIframeUrl('cpAccountManagement', { locationID: -1, isAddLocation: 'True' }) : buildIframeUrl('cpAccountManagement', { locationID: currentLocation?.LocationID });

	useEffect(() => {
		// Set document title
		document.title = `Account Management | ${META_TITLE}`;
	}, []);

	return (
		<S.Wrapper>
			<PageHeader>Account Management</PageHeader>
			<IframeView src={src} title="Account Management" />
		</S.Wrapper>
	);
}
